class CustomDropdown extends HTMLElement {
  constructor() {
    super();
    this.isOpen = false;
  }

  connectedCallback() {
    this.trigger = this.querySelector('.custom-dropdown__trigger');
    this.menu = this.querySelector('.custom-dropdown__menu');
    this.options = this.querySelectorAll('.custom-dropdown__option');
    this.hiddenInput = this.querySelector('input[type="hidden"]');

    if (this.trigger && this.menu) {
      this.trigger.addEventListener('click', () => this.toggle());

      this.options.forEach(option => {
        option.addEventListener('click', (e) => this.selectOption(e.currentTarget));
      });

      // Close dropdown when clicking outside
      document.addEventListener('click', (e) => {
        if (!this.contains(e.target)) {
          this.close();
        }
      });

      // Set initial selected value
      const selectedOption = this.querySelector('.custom-dropdown__option[data-selected="true"]');
      if (selectedOption) {
        this.updateTriggerText(selectedOption.textContent);
      }
    }
  }

  toggle() {
    this.isOpen ? this.close() : this.open();
  }

  open() {
    this.isOpen = true;
    this.menu.classList.add('custom-dropdown__menu--open');
    this.trigger.setAttribute('aria-expanded', 'true');
  }

  close() {
    this.isOpen = false;
    this.menu.classList.remove('custom-dropdown__menu--open');
    this.trigger.setAttribute('aria-expanded', 'false');
  }

  selectOption(option) {
    const value = option.dataset.value;
    const inputId = option.dataset.inputId;
    const optionValueId = option.dataset.optionValueId;
    const variantId = option.dataset.variantId;

    // Update hidden input with value and data attributes
    if (this.hiddenInput) {
      this.hiddenInput.value = value;
      // Copy data attributes to the hidden input so variant-picker can read them
      this.hiddenInput.dataset.optionValueId = optionValueId || '';
      this.hiddenInput.dataset.variantId = variantId || '';
      this.hiddenInput.dataset.inputId = inputId || '';
      this.hiddenInput.dataset.connectedProductUrl = option.dataset.connectedProductUrl || '';
    }

    // Update trigger text
    this.updateTriggerText(option.textContent);

    // Update selected state
    this.options.forEach(opt => {
      opt.classList.remove('custom-dropdown__option--selected');
      opt.removeAttribute('data-selected');
    });
    option.classList.add('custom-dropdown__option--selected');
    option.setAttribute('data-selected', 'true');

    // Dispatch native change event on hidden input so variant-picker can handle it
    if (this.hiddenInput) {
      const changeEvent = new Event('change', { bubbles: true });
      this.hiddenInput.dispatchEvent(changeEvent);
    }

    this.close();
  }

  updateTriggerText(text) {
    const valueElement = this.trigger.querySelector('.custom-dropdown__value');
    if (valueElement) {
      valueElement.textContent = text;
    }
  }
}

customElements.define('custom-dropdown', CustomDropdown);
